export const useStyles = (centered?: boolean) => ({
  loader: {
    position: 'absolute',
    zIndex: 999,
    ...(centered
      ? { top: '50%', marginTop: '-20px', marginLeft: '-20px', left: '50%' }
      : { top: '20%', left: '50%' }),
  },
});
